import {IPublicClientApplication} from "@azure/msal-browser";

/**
 * MSAL instance used during server-side rendering: there is no browser storage and no
 * token acquisition on the server, every call is inert.
 */
export function serverMsalInstance(): IPublicClientApplication {
  const logger = {
    verbose: () => {},
    error: () => {},
    warning: () => {},
    info: () => {},
    trace: () => {},
    clone: () => logger,
  };

  return {
    initialize: () => Promise.resolve(),
    getAllAccounts: () => [],
    acquireTokenSilent: () => Promise.reject('SSR'),
    logout: () => {},
    initializeWrapperLibrary: () => {},
    addEventCallback: () => null,
    removeEventCallback: () => {},
    addPerformanceCallback: () => null,
    removePerformanceCallback: () => {},
    handleRedirectPromise: () => Promise.resolve(null),
    loginPopup: () => Promise.reject('SSR'),
    loginRedirect: () => Promise.reject('SSR'),
    logoutPopup: () => Promise.reject('SSR'),
    logoutRedirect: () => Promise.reject('SSR'),
    getActiveAccount: () => null,
    setActiveAccount: () => {},
    getAccountByHomeId: () => null,
    getAccountByLocalId: () => null,
    getAccountByUsername: () => null,
    getLogger: () => logger,
  } as any;
}
